import { useState } from 'react'
import { Dialog, DialogBody, DialogContent, DialogFooter, DialogHeader, DialogTitle } from '@cutilei/ui'
import AuthService from 'services/auth'
import cutileiApi from 'services/cutileiApi'
import { getApiErrorMessage, logApiError } from 'services/apiError'
import DateReservation from 'services/DateReservation'
import DateInput from 'components/Inputs/DateInput'
import Select from 'components/Inputs/Select'
import MainButton from 'components/Buttons/MainButton'
import submitOnEnter from 'utils/submitOnEnter'
import dateReservationValidator from 'validators/dateReservationValidator'
import { Formik } from 'formik'

import {
  Form,
  FormField,
  Input,
  Row,
  WarningText,
  WhiteText,
  ErrorContainer
} from './styles'

export default function EditDateReservationModal ({
  visible,
  data: reservation,
  onConfirm: handleConfirm,
  onClose: handleClose
}) {
  const [errorMessage, setErrorMessage] = useState (null)
  const token = AuthService.getToken ()

  const requestConfig = {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  }

  return (
    <Dialog open={visible} onOpenChange={open => { if (!open) handleClose() }}>
      <DialogContent size='md' closeOnOutsideClick={false} aria-describedby={undefined}>
        <DialogHeader>
          <DialogTitle>Alterar reserva</DialogTitle>
        </DialogHeader>
        <Formik
          validationSchema={dateReservationValidator}
          initialValues={{
            'type': reservation.type,
            'description': reservation.description,
            'startDate': reservation.start_date,
            'endDate': reservation.end_date,
            'period': DateReservation.getPeriod (reservation)
          }}
          onSubmit={async (values, { setSubmitting }) => {
            const { startDate, endDate, period } = values

            const reservationData = {
              ...values,
              endDate: period.value === 0 ? startDate : endDate
            }

            try {
              const { data: editedReservation } = await cutileiApi.put (
                `/date_reservations/${reservation.id}`, reservationData, requestConfig
              )

              setSubmitting (false)
              handleConfirm (editedReservation)
              handleClose ()
            } catch (error) {
              setSubmitting (false)
              setErrorMessage (getApiErrorMessage (error))
              logApiError (error)
            }
          }}
        >
          {({
            values,
            errors,
            touched,
            isSubmitting,
            handleChange,
            handleBlur,
            setFieldValue,
            setFieldTouched,
            handleSubmit
          }) => {
            return (
              <>
                <DialogBody>
                  <Form onKeyDown={submitOnEnter(handleSubmit, isSubmitting)}>
                    <Row>
                      <FormField>
                        <Input
                          type='text'
                          name='description'
                          placeholder='Descrição da reserva'
                          value={values.description}
                          onChange={handleChange ('description')}
                          onBlur={handleBlur ('description')}
                        />
                        {touched.description && errors.description && (
                          <WarningText>
                            {errors.description}
                          </WarningText>
                        )}
                      </FormField>
                    </Row>
                    <Row>
                      <FormField>
                        <DateInput
                          placeholder='Data de início'
                          value={values.startDate}
                          onChange={date => setFieldValue ('startDate', date)}
                          style={{width: '100%'}}
                        />
                        {touched.startDate && errors.startDate && (
                          <WarningText>
                            {errors.startDate}
                          </WarningText>
                        )}
                      </FormField>
                      <FormField style={{marginLeft: 5, marginRight: values.period?.value === -2 ? 5 : 0}}>
                        <Select
                          name='period'
                          placeholder='Período...'
                          value={values.period}
                          options={DateReservation.PERIODS}
                          onChange={(name, option) => {
                            DateReservation.handlePeriodChange (name, option, values, setFieldValue)
                          }}
                          onBlur={setFieldTouched}
                          error={errors.period}
                          touched={touched.period}
                        />
                        {touched.period && errors.period && (
                          <WarningText>
                            {errors.period}
                          </WarningText>
                        )}
                      </FormField>
                      {values.period?.value === -2 &&
                        <FormField>
                          <DateInput
                            placeholder='Data final'
                            value={values.endDate}
                            onChange={date => setFieldValue ('endDate', date)}
                            style={{width: '100%'}}
                          />
                          {touched.endDate && errors.endDate && (
                            <WarningText>
                              {errors.endDate}
                            </WarningText>
                          )}
                        </FormField>
                      }
                    </Row>
                    {errorMessage && (
                      <ErrorContainer>
                        <WhiteText>{errorMessage}</WhiteText>
                      </ErrorContainer>
                    )}
                  </Form>
                </DialogBody>
                <DialogFooter>
                  <MainButton
                    label='Salvar alterações'
                    onClick={handleSubmit}
                    disabled={isSubmitting}
                    loading={isSubmitting}
                    width={180}
                  />
                </DialogFooter>
              </>
            )
          }}
        </Formik>
      </DialogContent>
    </Dialog>
  )
}
